import {OverlayContainer} from "../../../misc/ImageViewer";
import Settings from "../../../settings/Settings";
import React, {useEffect, useRef, useState} from "react";
import SchemaEditContainer from "../SchemaEditContainer";
import {SqlQuery} from "../BackTableFieldViewTable";
import {useAppDispatch, useAppSelector} from "../../../../hooks";
import {schemas} from "../../../../config";
import {
    PHP_TYPE_MAP,
    PhpType,
    setBackTableJoin,
    setBackTableNullableFields,
    setBackTableUpdateField
} from "../../../../features/schemaManageSlice";
import styled from "styled-components";


type PropsI = {
    closeEditing: () => void,
};
export default function EditNull({closeEditing}: PropsI) {

    const tableName = useAppSelector(state => state.schemaManage.back.selectedTable) as string;
    const table = useAppSelector(state => state.schemaManage.back.tables[tableName]);
    const ethereal = useAppSelector(state => state.schemaManage.back.etherealTables[tableName])!;

    const [newValue, setNewValue] = useState(ethereal.nullableFields)
    const [option, setOption] = useState("")

    const dispatch = useAppDispatch();

    const fields = Object.keys(table.fieldsList);
    const availableFields = fields.filter(f => !newValue.includes(f));
    const deleteField = (field: string) => setNewValue(prevState => prevState.filter(f => f !== field));

    const addField = (field: string) => setNewValue(prevState => Array.from(new Set(prevState.concat(field))));

    useEffect(() => {
        if (availableFields.length > 0)
            setOption(availableFields[0])
    }, [availableFields]);

    return <OverlayContainer $isVisible>
        <SchemaEditContainer>
            <Container>
                <div>Редагувати Nullable поля</div>
                {availableFields.length > 0 && <div className="edit-field-dep-add">
                    <div className={'sel'}>
                        <select name="keys" id="keys" value={option} onChange={(e) => setOption(e.target.value)}>
                            {availableFields.map(f => <option value={f} key={f}>{f}</option>)}
                        </select>
                        <button className={'btn-cmn'}
                                onClick={() => addField(option)}>Додати
                        </button>
                    </div>
                </div>}
                <div className="all-deps">
                    {newValue.map((f, i) => {
                        return <div className={'outer-dep'} key={i}>
                            <div className="dep-view">
                                <span className={'dep'}>{f}</span>
                            </div>
                            <button className="del-dep btn-cmn" onClick={() => deleteField(f)}>
                                ❌
                            </button>
                        </div>
                    })}
                </div>

                <div className={'controls'}>
                    <button className={'save btn-cmn'} onClick={() => {
                        dispatch(setBackTableNullableFields({
                            table: tableName,
                            value: newValue
                        }))
                        closeEditing()
                    }}>
                        Зберегти
                    </button>
                    <button className="close btn-cmn" onClick={closeEditing}>
                        ❌
                    </button>
                </div>
            </Container>
        </SchemaEditContainer>
    </OverlayContainer>

}

const Container = styled.div`
    width: 100%;
    display: flex;
    flex-flow: column;
    gap: .5rem;


    .delete-field {
        display: flex;
        gap: .5rem;
        flex-wrap: wrap;
        align-items: center;
    }

    .all-deps {
        display: flex;
        gap: .5rem;
        flex-wrap: wrap;
        max-width: 700px;
    }

    .outer-dep {
        display: flex;
        gap: .2rem;
        align-items: center;
        flex-wrap: wrap;

        .dep {
            padding: .2rem .4rem;
            border-radius: .2rem;
            background-color: black;
            color: white;
        }
    }

    .edit-field-dep-add {
        display: flex;
        flex-flow: column;
        gap: .5rem;

        .sel {
            display: flex;
            gap: .5rem;
        }
    }
`

